/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::coins::register`. */
export const register = "0x1::coins::register" as const;
